module.exports = __webpack_public_path__ + "static/person.3a590cd0.svg";